import React from "react";
import { Outlet } from "react-router-dom";

import Header from "../../Components/Header";
import Main from "../../Components/Main";
import Footer from "../../Components/Footer";
import BackToTop from "../../Components/BackToTop";

// Componente base para as páginas, onde o Outlet é o local onde as páginas serão renderizadas, 
// Main é o componente que envolve o conteúdo principal da página, e 
// Header e Footer são componentes fixos que aparecem em todas as páginas.


function PageTemplate() {
    return (
        <main>
            <Header />
                <Main>
                    <Outlet />
                </Main>
            <Footer />
            <BackToTop />
        </main>
    );
}

export default PageTemplate;